import { SelectMenu } from '@scale/scaleui';
import { CompassCardComponentProps } from 'react-scale/corp/views/DataCompassV2/types';
import { useCompassCard } from '@scale/compass-ui/store';

export interface ColumnPickerProps {
  cardComponentProps: CompassCardComponentProps;
  selectedColumnWithObjectIds: string | undefined;
  setSelectedColumnWithObjectIds: (selectedColumnWithObjectIds: string) => void;
}

export default function ColumnPicker({
  cardComponentProps,
  selectedColumnWithObjectIds,
  setSelectedColumnWithObjectIds,
}: ColumnPickerProps) {
  const { retrievedOutput } = useCompassCard(cardComponentProps.index - 1);
  const columns = retrievedOutput?.response?.schema || [];

  return (
    <SelectMenu
      className="w-96"
      menuDirection="bottom"
      options={columns.map(column => ({
        id: column.id ?? '-',
        name: column.header ?? '-',
      }))}
      selectedOptionId={selectedColumnWithObjectIds ?? ''}
      setSelected={(v: string) => setSelectedColumnWithObjectIds(v)}
      disabled={false}
    />
  );
}
